import { range } from 'lodash';
import { css } from 'styled-components';
import { horizontalShaking } from './animations/shaking';
import { loadingBouncing, loadingScale } from './animations/loading-text';

export const horizontalShake = (seconds: number) => css`
  animation: ${horizontalShaking} ${seconds}s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000px;
`;

export const loadingTextScale = (seconds, textLength: number) => css`
  & > * {
    display: inline-block;
    white-space: break-spaces;
    animation: ${loadingScale} ${seconds}s infinite alternate;
    ${range(textLength).map((letterIndex) => `
      &:nth-child(${letterIndex + 1}) {
        animation-delay: ${letterIndex * 0.1}s;
      }
    `)}
  }
`;

export const loadingTextBouncing = (seconds, textLength: number) => css`
  & > * {
    display: inline-block;
    white-space: break-spaces;
    animation: ${loadingBouncing} ${seconds}s infinite;
    ${range(textLength).map((letterIndex) => `
      &:nth-child(${letterIndex + 1}) {
        animation-delay: ${letterIndex * 0.1}s;
      }
    `)}
  }
`;
